import type { Assessment, AssessmentStart } from '@brighterly/lib-core-types/assessment/interfaces'

import { useAssessmentsStore } from '@stores/assessments'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

import { isObject, pick } from '@helpers/object'

import { getNotifyTypeFromUrl } from '@tools/amplitude/notify-type'

interface AssessmentsApiPayload {
  disciplineId: number
}

interface AssessmentsApiReturn {
  get: () => Promise<Assessment[] | AssessmentStart>
}
export const useAssessmentsApi = (payload: AssessmentsApiPayload): AssessmentsApiReturn => {
  const { $axios } = useNuxtApp()
  const route = useRoute()

  const assessmentsStore = useAssessmentsStore()

  const get = async (): Promise<Assessment[] | AssessmentStart> => {

    const url = useCsRoutes('assessments', pick({
      '[discipline_id]': payload.disciplineId,
      notify_type: getNotifyTypeFromUrl(route),
    }))

    try {
      const { data } = await $axios.get(url!)

      if (isObject(data.data)) {
        assessmentsStore.setAssessments([])

        const assessmentStart: AssessmentStart = data.data
        assessmentsStore.setAssessmentAutologinUrl(assessmentStart.autologin_url)
        assessmentsStore.setAssessmentAutologinSharedUrl(assessmentStart.share_url)
      } else {
        const assessments: Assessment[] = data.data || []
        assessmentsStore.setAssessments(assessments)
        assessmentsStore.setAssessmentAutologinUrl(null)
        assessmentsStore.setAssessmentAutologinSharedUrl(null)
      }

      return data.data
    } catch (err) {
      console.error(err)

      const assessments: Assessment[] = []

      assessmentsStore.setAssessments(assessments)
      assessmentsStore.setAssessmentAutologinUrl(null)
      assessmentsStore.setAssessmentAutologinSharedUrl(null)
      return []
    }
  }

  return {
    get,
  }
}
